import { createEffect } from 'effector'
import { pedantBaseApi } from 'api'
import { IAppSettings } from '../types'

export const loadAppSettingsFx = createEffect({
  handler () {
    return pedantBaseApi.get<IAppSettings>('/api/settings')
  }
})
